import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import {
	ToastAlertSuccess,
	ToastAlertError,
	LoadingButton,
} from "../reauseble";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import PageHeader from "../pages/components/PagesHeaderComponent/PageHeader";
import { Input, Tabs } from "antd";
import { Button } from "react-bootstrap";
import loginImg from "../assets/images/register-login.png"
import { useLocation } from "react-router-dom/dist";
const Login = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [currentTab, setCurrentTab] = useState(1);
	const [loading, setLoading] = useState(false);

	const [signUpCred, setSignUpCred] = useState({
		firstName: "",
		lastName: "",
		number: "",
		email: "",
		password: "",
		confirmPassword: "",
	});
	const [signInCred, setSignInCred] = useState({
		email: "",
		password: "",
	});



	const items = [
		{
			key: '1',
			label: 'Sign In',
			children: (
				<>
					<div className="inputs logInInp">
						<Input placeholder="Email" value={signInCred.email}
							required
							onChange={(e) =>
								setSignInCred({ ...signInCred, email: e.target.value })
							} />
						<Input placeholder="Password" required
							value={signInCred.password}
							onChange={(e) =>
								setSignInCred({ ...signInCred, password: e.target.value })
							} />
						{/* <button className="rounded_btn">Sign In</button> */}
						{/* <div className='field_wrap hlf_div'>
							<input
								type='checkbox'
								name=''
							/>{" "}
							Remember Me
						</div> */}
						<Link to='/forgotpassword'> Forgot your password? </Link>
						<Button className="signUp_btn" variant="primary">Sign In</Button>

					</div>
				</>
			),
		},
		{
			key: '2',
			label: 'Sign Up',
			children: (
				<>
					<div className="inputs signUpInp">
						<Input placeholder="First Name*" required
							value={signUpCred.firstName}
							onChange={(e) =>
								setSignUpCred({ ...signUpCred, firstName: e.target.value })
							} />
						<Input placeholder="Last Name*" required
							value={signUpCred.lastName}
							onChange={(e) =>
								setSignUpCred({ ...signUpCred, lastName: e.target.value })
							} />
						<Input placeholder="Contact Number*" required
							value={signUpCred.number}
							onChange={(e) =>
								setSignUpCred({ ...signUpCred, number: e.target.value })
							} />
						<Input placeholder="Email Address*" value={signUpCred.email}
							required
							onChange={(e) =>
								setSignUpCred({ ...signUpCred, email: e.target.value })
							} />
						<Input placeholder="Password*" required
							value={signUpCred.password}
							onChange={(e) =>
								setSignUpCred({ ...signUpCred, password: e.target.value })
							} />
						<Input placeholder="Confirm Password*" required
							value={signUpCred.confirmPassword}
							onChange={(e) =>
								setSignUpCred({
									...signUpCred,
									confirmPassword: e.target.value,
								})
							} />
						<Button className="signUp_btn" variant="primary">Sign Up</Button>

					</div>
				</>
			),
		},

	];

	const handleSubmit = (e) => {
		setLoading(true);
		e.preventDefault();
		CoreHttpHandler.request(
			"customers",
			"login",
			{
				username: username,
				password: password,
			},
			(response) => {
				setLoading(false);
				const token = response.data.data.token;
				localStorage.setItem("user_token", token);

				ToastAlertSuccess("you have Login Successfully");

				setTimeout(() => {
					navigate("/");
					window.location.reload(false);
				}, 2000);
			},
			(err) => {
				setLoading(false);

				ToastAlertError(
					err?.response?.data?.message
						? err?.response.data.message
						: "something went wrong"
				);
			}
		);
	};
	const onChange = (key) => {
		setCurrentTab(Number(key));
		// console.log(typeof key)
	};
	return (
		<>
			<PageHeader heading={currentTab === 1 ? "Sign In" : "Sign Up"} />
			<section className='main_form'>
				{/* <canvas></canvas> */}
				<div className='container flex_btw'>
					<div className="login_img">
						<img src={loginImg} />
					</div>

					<div className='inner_sec'>
					
					{/* {location.pathname === "/forgotpassword" ?
					<h1>Forgot</h1>
					: */}
						<Tabs defaultActiveKey="1" items={items} onChange={onChange} />
					 {/* } */}



						{/* <LoadingButton
									loading={loading}
									onClick={handleSubmit}
								/> */}

						{/* <div className='bottom_wrap'>
							<p>
								Don't have an account?{" "}
								<Link to='/registerform'> Register Now </Link>
							</p>
						</div> */}
					</div>
				</div>
			</section>
		</>
	);
};

export default Login;
